import { Injectable, signal, WritableSignal } from '@angular/core';
import { Tenant } from '../shared/models/tenant.model';

/**
 * Tenant State Service for Streamlined Agrar
 * Stores current tenant (Streamlined Agrar) information in application state
 * Tenant is always required - loaded on app initialization
 */
@Injectable({
  providedIn: 'root'
})
export class TenantStateService {
  
  private readonly tenantSignal: WritableSignal<Tenant | null> = signal(null);
  
  /**
   * Get current tenant
   * Returns tenant signal for reactive access
   */
  readonly tenant = this.tenantSignal.asReadonly();
  
  /**
   * Set current tenant
   */
  setTenant(tenant: Tenant): void {
    console.log('[TenantStateService] Setting tenant:', tenant.tenantName, tenant.uuid);
    this.tenantSignal.set(tenant);
  }
  
  /**
   * Clear tenant
   */
  clearTenant(): void {
    console.log('[TenantStateService] Clearing tenant');
    this.tenantSignal.set(null);
  }
}


